<template>
    <table class="table table-striped">
        <thead>
            <tr>
                <th class="th-first">
                    {{ __("price_list_type") }}
                </th>
                <th>{{ __("country_or_name") }}</th>
                <th>{{ __("currency") }}</th>
                <th>{{ __("status") }}</th>
                <th class="th-before th-last"></th>
            </tr>
        </thead>
        <tbody>
            <tr
                class="row-click row-odd"
                v-for="priceList in priceListsOrdered"
            >
                <input
                    type="hidden"
                    :value="priceList.id"
                    name="priceLists[]"
                />

                <td class="td-padding">
                    {{ __("price_list_type_" + priceList.type) }}
                </td>
                <td class="td-padding">{{ priceList.countryOrName }}</td>
                <td class="td-padding">{{ priceList.currency.iso_code }}</td>
                <td class="td-padding">
                    <status-label :status="priceList.status" />
                </td>
                <td class="text-right table-icons">
                    <a v-if="inNewWindow === '1'"
                        :href="showRoute(priceList.id)"
                        data-toggle="tooltip"
                        target="_blank"
                        data-placement="top"
                        title=""
                        :data-original-title="__('show')"
                        ><i class="fa fa-eye"></i
                    ></a>
                    <a v-else
                       :href="showRoute(priceList.id)"
                       data-toggle="tooltip"
                       target="_blank"
                       data-placement="top"
                       title=""
                       :data-original-title="__('show')"
                    ><i class="fa fa-eye"></i
                    ></a>
                    <a
                        href="#"
                        :class="
                            priceList.status == 'archival'
                                ? 'icon-inactive'
                                : ''
                        "
                        data-toggle="tooltip"
                        data-placement="top"
                        title=""
                        data-original-title=""
                        @click.prevent="removePriceList(priceList)"
                        v-if="mode != 'preview'"
                        ><i class="fa fa-trash"></i
                    ></a>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import StatusLabel from "./StatusLabel";
import { mapActions } from "vuex";

export default {
    components: {
        StatusLabel
    },
    props: {
        priceLists: {
            type: Array,
            default: []
        },
        previewRoute: {
            type: String
        },
        mode: {
            type: String
        },
        currentRoute: {
            type: String,
            default: ""
        },
        inNewWindow: {
            type: String,
            default: ""
        }
    },
    computed: {
        priceListsOrdered() {
            return this.priceLists.sort(function(a, b) {
                return a.date_from < b.date_from ? 1 : -1;
            });
        }
    },
    methods: {
        removePriceList(priceList) {
            if (priceList.status != "archival") {
                let self = this;
                this.$swal({
                    title: self.__("delete_price_list_from_client"),
                    text: self.__(
                        "it_will_not_be_possible_to_retrieve_it_later_!"
                    ),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: self.__("delete"),
                    cancelButtonText: self.__("cancel"),
                    closeOnConfirm: true,
                    reverseButtons: true
                }).then(result => {
                    if (result.value == true) {
                        if (this.mode == "edit") {
                            this.removeClientPriceLists(priceList);
                        } else {
                            this.unsetClientPriceLists(priceList);
                        }
                    }
                });
            }
        },
        showRoute(priceListId) {
            return `${this.previewRoute}/${priceListId}?return=${this.currentRoute}?&buttons=0`;
        },
        ...mapActions(["removeClientPriceLists", "unsetClientPriceLists"])
    }
};
</script>

<style lang="scss" scoped></style>
